import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { iniciais } from '../../utils/formato';
import { labelPerfil } from '../../utils/webhookOpcoes';

const GRUPOS = [
  {
    label: 'Operação',
    itens: [
      { path: '/dashboard', label: 'Dashboard', icon: 'bi-speedometer2', minPerfil: null },
      { path: '/eventos', label: 'Eventos', icon: 'bi-inbox', minPerfil: null },
      { path: '/endpoints', label: 'Endpoints', icon: 'bi-hdd-network', minPerfil: null },
      { path: '/quarentena', label: 'Não identificadas', icon: 'bi-question-octagon', minPerfil: 'operador' },
    ],
  },
  {
    label: 'Cadastros',
    itens: [
      { path: '/cadastros/clientes', label: 'Clientes', icon: 'bi-person-badge', minPerfil: 'operador' },
      { path: '/cadastros/sistemas', label: 'Sistemas', icon: 'bi-boxes', minPerfil: 'operador' },
    ],
  },
  {
    label: 'Sistema',
    itens: [
      { path: '/usuarios', label: 'Usuários', icon: 'bi-people', minPerfil: 'operador' },
      { path: '/auditoria', label: 'Auditoria', icon: 'bi-clock-history', minPerfil: 'admin' },
    ],
  },
  {
    label: 'Ajuda',
    itens: [
      // por último e sem restrição de perfil: é a porta de entrada de quem não mexe com
      // integração no dia a dia
      { path: '/documentacao', label: 'Documentação', icon: 'bi-book', minPerfil: null },
    ],
  },
];

const HIERARQUIA = { admin: 3, operador: 2, consulta: 1 };

export default function Sidebar({ abertoMobile, onFecharMobile }) {
  const { user, logout } = useAuth();

  return (
    <aside className={`app-sidebar${abertoMobile ? ' is-mobile-open' : ''}`}>
      <div className="app-sidebar__brand">
        <i className="bi bi-broadcast-pin" />
        <span>Webhook Datafit</span>
      </div>

      <div style={{ overflowY: 'auto', flex: 1 }}>
        {GRUPOS.map((grupo) => {
          const itens = grupo.itens.filter(
            (item) => !item.minPerfil || HIERARQUIA[user?.perfil] >= HIERARQUIA[item.minPerfil]
          );
          if (!itens.length) return null;
          return (
            <div key={grupo.label}>
              <div className="app-sidebar__group-label">{grupo.label}</div>
              <nav className="app-sidebar__nav">
                {itens.map((item) => (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    onClick={onFecharMobile}
                    className={({ isActive }) => `app-sidebar__link${isActive ? ' is-active' : ''}`}
                  >
                    <i className={`bi ${item.icon}`} />
                    <span>{item.label}</span>
                  </NavLink>
                ))}
              </nav>
            </div>
          );
        })}
      </div>

      <div className="app-sidebar__footer">
        <NavLink to="/perfil" className="d-flex align-items-center gap-2 text-decoration-none flex-grow-1" style={{ minWidth: 0 }} onClick={onFecharMobile}>
          <div className="app-sidebar__avatar">{iniciais(user?.nome)}</div>
          <div style={{ minWidth: 0 }}>
            <div className="app-sidebar__user-name">{user?.nome}</div>
            <div className="app-sidebar__user-role">{labelPerfil(user?.perfil)}</div>
          </div>
        </NavLink>
        <button type="button" className="app-sidebar__logout" onClick={logout} title="Sair">
          <i className="bi bi-box-arrow-right" />
        </button>
      </div>
    </aside>
  );
}
